@if (!!checkIMEIForm) {
  <form [formGroup]="checkIMEIForm">
    <p class="imei-confirmation-text">Først må vi sjekke at det er den riktige mobilen som byttes inn.</p>
    <p class="imei-confirmation-text">Sjekk at IMEI-nummeret på mobilen som byttes inn er:</p>
    <app-ice-alert type="info">
      <b>IMEI:&nbsp;</b>
      {{ oldIMEI }}
    </app-ice-alert>
    <app-information-button
      [activeLabel]="'Skjul informasjon'"
      [inactiveLabel]="'Hvordan finne IMEI?'"
      (toggleInfo)="toggleHowToFindIMEI()"
    />
    <app-ice-checkbox
      forId="is-imei-matching"
      label="Ja, IMEI-nummeret er likt"
      ngDefaultControl
      testId="is-imei-matching-input"
      [errorOnTouchedOnly]="true"
      [formControl]="isIMEIMatching"
    />
  </form>
} @else {
  <app-spinner />
}
